// Layout
const VerticalLayout = () => import('@/layouts/VerticalLayout')

const supportList = () => import('./views/list')

// start routes
export default [
  {
    path: '/support',
    name: 'support',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'support',
      component: supportList,
      meta: { name: 'support', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
